import { StringHelpers } from '../..';

type ErrorLineParams = {
  state: string;
  errorMessage?: string;
  renderedSource?: string;
};

export const annotateSqlWithSyntaxError = function ({
  state,
  errorMessage,
  renderedSource,
}: ErrorLineParams): string | undefined {
  if (state !== 'failed' || !errorMessage || !renderedSource) {
    return;
  }

  const position = errorMessage.match(/position: (\d+)/i);

  if (!position || !position[1]) {
    return;
  }

  const pos = parseInt(position[1], 10);

  let start = renderedSource.substring(0, pos);
  let end = renderedSource.substring(pos);

  const startPos = start.lastIndexOf('\n');
  const prevLinePos = start.lastIndexOf('\n', startPos - 1);

  const endPos = end.indexOf('\n');
  const nextLinePos = end.indexOf('\n', endPos + 1);

  let prevLine = '';
  let nextLine = '';

  if (startPos >= 0) {
    if (prevLinePos >= 0) {
      prevLine = '<pre>' + StringHelpers.escapeHTML(start.substring(prevLinePos + 1, startPos)) + '</pre>';
    } else {
      prevLine = '<pre>' + StringHelpers.escapeHTML(start.substring(0, startPos)) + '</pre>';
    }
    start = start.substring(startPos + 1);
  }

  if (endPos >= 0) {
    if (nextLinePos >= 0) {
      nextLine = '<pre>' + StringHelpers.escapeHTML(end.substring(endPos + 1, nextLinePos)) + '</pre>';
    } else {
      nextLine = '<pre>' + StringHelpers.escapeHTML(end.substring(endPos + 1)) + '</pre>';
    }
    end = end.substring(0, endPos);
  }

  const space = new Array(start.length).join(' ');

  return (
    prevLine +
    '<pre>' +
    StringHelpers.escapeHTML(start + end) +
    '</pre>' +
    '<pre class="highlight">' +
    space +
    '^' +
    '</pre>' +
    nextLine
  );
};
